module.exports = __webpack_public_path__ + "img/la_poste_vsmp_2019.a62d24dc.jpg";